import React, { FC } from 'react';
import { IExternalLink } from '../../../../../../interfaces/professional/Professional';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import WorkingHours from '../../../../../Common/WorkingHours/WorkingHours';
import * as classes from './HeroSection.module.scss';
import ContactListItem from '../../../Components/ContactListItem/ContactListItem';
import { GetInTouchHeroSectionProps } from '../../../../../Sections/GetInTouch/HeroSection/HeroSection';

const HeroSection: FC<GetInTouchHeroSectionProps> = ({ openingTime, phone, email, externalLinks }) => {
  const { t } = useTranslation();
  const externalLinksMapper = (item: IExternalLink, index: number) => (
    <ContactListItem key={index} label={item.linkDescription} value={<a href={item.url}>{item.url}</a>} />
  );

  return (
    <Section number={'01'} label={t('getInTouch.heroSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className='row'>
          <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 order-md-0 order-1'>
            <WorkingHours {...openingTime} isBolderTitle />
          </div>
          <div className='col-xl-7 offset-lg-1 col-lg-7 col-md-6 col-sm-12 order-md-1 order-0'>
            <div className={classes.contactsWrapper}>
              <ContactListItem label={t('getInTouch.heroSection.contacts.phone')} value={<a href={`tel:${phone}`}>{phone}</a>} />
              <ContactListItem label={t('getInTouch.heroSection.contacts.email')} value={<a href={`mailto:${email}`}>{email}</a>} />
              {externalLinks.map(externalLinksMapper)}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default HeroSection;
